import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const playerAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  // Only SuperAdmin and Admin can access players
  if (!authService.hasAnyRole('Admin', 'SuperAdmin')) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
